import { render } from "./cdrBatchType.vue?vue&type=template&id=122bd6a2&scoped=true"
import script from "./cdrBatchType.vue?vue&type=script&lang=js"
export * from "./cdrBatchType.vue?vue&type=script&lang=js"

import "./cdrBatchType.vue?vue&type=style&index=0&id=122bd6a2&scoped=true&lang=css"
import "./cdrBatchType.vue?vue&type=style&index=1&id=122bd6a2&lang=css"
script.render = render
script.__scopeId = "data-v-122bd6a2"

export default script